var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m160.609 61.929 56.568 56.568L99.11 236.564A10 10 0 0 1 94 239.3l-53.033 10.607c-6.997 1.4-13.167-4.77-11.767-11.767l10.606-53.033a10 10 0 0 1 2.735-5.11zm77.78-21.213c15.622 15.62 15.622 40.947 0 56.568l-7.07 7.071-56.568-56.568 7.07-7.071c15.622-15.621 40.948-15.621 56.569 0"
})));
export default SvgEdit;